import React, { useState, useEffect, useCallback } from 'react';
import { Card, Button, Modal, ListGroup, Badge } from 'react-bootstrap';
import SablonFormu from './SablonFormu';
import api from './api';

function Sablonlarim() {
  const [sablonlar, setSablonlar] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [duzenlenenSablon, setDuzenlenenSablon] = useState(null);
  
  const sablonlariGetir = useCallback(async () => {
      try {
        const response = await api.get('/diyetisyen/sablon-ogunler');
        setSablonlar(response.data);
      } catch (error) { console.error("Şablonlar getirilemedi:", error); }
  }, []);

  useEffect(() => { sablonlariGetir(); }, [sablonlariGetir]);

  const handleSil = async (sablonId) => {
    if (!window.confirm('Bu şablonu silmek istediğinizden emin misiniz?')) return;
    try {
      await api.delete(`/diyetisyen/sablon-ogunler/${sablonId}`);
      sablonlariGetir();
    } catch (error) { alert(error.response?.data?.mesaj || 'Silme işlemi başarısız'); }
  };

  const handleFormSubmit = async (formData) => {
    const isUpdating = !!duzenlenenSablon?.id;
    const url = isUpdating ? `/diyetisyen/sablon-ogunler/${duzenlenenSablon.id}` : '/diyetisyen/sablon-ogunler';
    const method = isUpdating ? 'put' : 'post';
    try {
      await api[method](url, formData);
      setShowModal(false);
      sablonlariGetir();
    } catch (error) { alert(`Hata: ${error.response?.data?.mesaj || 'İşlem başarısız'}`); }
  };

  const handleModalOpen = (sablon = null) => {
    setDuzenlenenSablon(sablon);
    setShowModal(true);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="text-light">Şablon Öğünlerim</h2>
        <Button variant="light" onClick={() => handleModalOpen()}>+ Yeni Şablon Oluştur</Button>
      </div>
      {sablonlar.map(sablon => (
        <Card key={sablon.id} className="mb-3 glass-card text-white">
          <Card.Header>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <Card.Title as="h5" className="mb-1">{sablon.ad}</Card.Title>
                {sablon.kategori && <Badge bg="info">{sablon.kategori.ad}</Badge>}
              </div>
              <div>
                <Button variant="warning" size="sm" onClick={() => handleModalOpen(sablon)}>Düzenle</Button>
                <Button variant="danger" size="sm" className="ms-2" onClick={() => handleSil(sablon.id)}>Sil</Button>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <ListGroup variant="flush">
              {sablon.icerikler.map((icerik, index) => (
                <ListGroup.Item key={index}>
                  {icerik.miktar} {icerik.olcu_birimi.ad} - {icerik.besin.ad}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Card.Body>
          <Card.Footer className="d-flex justify-content-around small">
            <span>Kcal: {sablon.toplam_kalori || 0}</span>
            <span>P: {sablon.toplam_protein || 0}g</span>
            <span>K: {sablon.toplam_karbonhidrat || 0}g</span>
            <span>Y: {sablon.toplam_yag || 0}g</span>
          </Card.Footer>
        </Card>
      ))}
      
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{duzenlenenSablon?.id ? 'Şablon Düzenle' : 'Yeni Şablon Oluştur'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SablonFormu 
            mevcutSablon={duzenlenenSablon}
            onFormSubmit={handleFormSubmit}
            onIptal={() => setShowModal(false)}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default Sablonlarim;